import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";

export default class KYCreverification extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div>
        <div className="row widget_BG widget_BG_grid d-flex m-0 mt-2">
          <h5 className="logoskybluecolor">Re-KYC Verfication</h5>

          <Form>
            <div className="col-md-4">
              <Form.Group>
                <Form.Label>Confirm OTP</Form.Label>
                <p>
                  OTP sent To Aadhaar registered mobile number ending with ...
                </p>
                <Form.Control
                  type="text"
                  className="kycOTP"
                  label="Deactivate my ABHA number temporarily"
                  name="deactivate"
                  checked={this.state.deactivate}
                  onChange={this.handleCheckDeactiveChange}
                />
              </Form.Group>
              <p>
                Did't receive OTP? <a href="/">Resend OTP</a>
              </p>
            </div>
          </Form>
          <div className="col text-end">
            <Button className="rounded-0">Continue</Button>
          </div>
        </div>
      </div>
    );
  }
}
